import * as React from "react";
import Component from "../../../../AbstractComponent";

export class Subtitle extends Component {

  constructor(public props) {
    super(props);
  }

  public render() {
    const { subtitle } = this.props;
    return (
        <div 
            style={{textAlign: "center", marginBottom: "30px", fontSize: "14px", ...this.props?.style}}
            className={this.props?.className}
        >
            {subtitle}
        </div>
    );
  }
}
